<template>
  <div
    class="userPage"
    :style="`background: #2A79FF url(${systemBgUrl}) no-repeat;background-size: cover;`"
  >
    <div class="wrap">
      <div class="sysName">
        <div class="img">
          <img v-if="schoolLogo" :src="schoolLogo" alt="" />
        </div>
        <div class="line" v-if="schoolLogo"></div>
        <div class="name">{{ systemName }}</div>
      </div>
      <div class="con">
        <div class="mobile">
          <h3>微信扫码确认</h3>
          <div class="ewm">
            <qriously :value="codeValue" :size="230" v-if="codeValue" />
            <img :src="require('@/assets/ewm.png')" alt="" v-else />
            <div class="desc">简单易用 无需安装</div>
          </div>
        </div>
        <div class="user">
          <a-form
            id="formLogin"
            class="user-layout-login"
            :form="form"
            ref="formLogin"
            @submit="handleSubmit"
          >
            <div class="container">
              <h3>PC登录</h3>
              <a-form-item>
                <a-input
                  class="cus-input"
                  size="large"
                  type="text"
                  placeholder="请输入账号/手机号"
                  v-decorator="[
                    'username',
                    {
                      rules: [{ required: true, message: '请输入账号/手机号' }],
                      validateTrigger: 'blur',
                    },
                  ]"
                >
                  <a-icon
                    slot="prefix"
                    type="user"
                    :style="{ color: 'rgba(0,0,0,.25)' }"
                  />
                </a-input>
              </a-form-item>
              <a-form-item style="margin-bottom: 8px">
                <a-input-password
                  class="cus-input"
                  size="large"
                  type="password"
                  autocomplete="false"
                  placeholder="请输入密码"
                  v-decorator="[
                    'password',
                    {
                      rules: [{ required: true, message: '请输入密码' }],
                      validateTrigger: 'blur',
                    },
                  ]"
                >
                  <a-icon
                    slot="prefix"
                    type="lock"
                    :style="{ color: 'rgba(0,0,0,.25)' }"
                  />
                </a-input-password>
              </a-form-item>

              <a-form-item style="margin: 0 8px 44px">
                <a-checkbox :checked="isKeep" @change="keepMe">
                  记住我
                </a-checkbox>
                <router-link style="float: right; color: #666" to="/forgot"
                  >找回密码</router-link
                >
              </a-form-item>

              <a-form-item>
                <a-button
                  type="primary"
                  size="large"
                  block
                  htmlType="submit"
                  class="login-button"
                  >登 录</a-button
                >
              </a-form-item>

              <div style="text-align: center">
                首次登录？请先 <a @click="register">核验身份</a>
              </div>
            </div>
          </a-form>
        </div>
      </div>
    </div>
    <!-- 客服在线服务（已隐藏，保留代码）
    <div class="fixed">
      <div class="group">
        <div class="icon"></div>
        <div>客服在线服务</div>
      </div>
      <div class="groupImg">
        <img :src="require('@/assets/contact_me_qr.png')" alt="" />
        <div>客服在线服务群</div>
      </div>
    </div>
    -->
  </div>
</template>

<script>
import { userLogin, getUserInfo, getWebConfig, getQriously } from "@/api/api";
import { getFlag } from "@/api/common";
import { timeFix } from "@/utils/util";
import { encrypt } from "@/utils/encrypt";

export default {
  name: "Login",
  data() {
    return {
      form: this.$form.createForm(this),
      isKeep: false,
      systemBgUrl: require("@/assets/pcStu.png"),
      systemName: "单招报名系统",
      // schoolLogo: require('@/assets/logo.png'),
      schoolLogo: "",
      systemLogo: "",
      codeValue: "",
    };
  },
  methods: {
    // 注册
    register() {
      console.log(this.$route.query.uvCode, "1212821821821");
      this.$router.push({
        path: "register",
        query: { uvCode: this.$route.query.uvCode },
      });
      // getFlag({
      //   paramKey: "register",
      //   uvCode: localStorage.getItem("uvCode"),
      // }).then(res => {
      //   if (res.data.paramValue == 1) {
      //     this.$router.push({ path: '/register' })
      //   } else {
      //     this.$message.error('暂未开启')
      //   }
      // })
    },
    keepMe(e) {
      this.isKeep = e.target.checked;
      console.log(`checked = ${e.target.checked}`);
      localStorage.setItem("isKeep", this.isKeep);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          userLogin({
            username: values.username.trim(),
            password: encrypt(values.username.trim(), values.password.trim()),
            uvCode: this.$route.query.uvCode,
          }).then((res) => {
            if (res.code == 0) {
              // localStorage.setItem("firstLogin", true);
              if (res.data.code == 0) {
                if (this.isKeep) {
                  localStorage.setItem("username", values.username);
                  localStorage.setItem("password", values.password);
                }
                this.getUserInfo();
              } else if (res.data.code == 1) {
                const _this = this;
                this.$confirm({
                  title: "提示",
                  content: res.data.msg,
                  onOk() {
                    getUserInfo().then((res) => {
                      localStorage.setItem(`user`, JSON.stringify(res));
                      localStorage.setItem(`sCode`, res.scode);
                      localStorage.setItem(`uvCode`, res.uvCode);
                      _this.$router.push({
                        path: "/mine",
                        query: {
                          curTab: 1,
                        },
                      });
                    });
                  },
                  onCancel() {
                    if (_this.isKeep) {
                      localStorage.setItem("username", values.username);
                      localStorage.setItem("password", values.password);
                    }
                    _this.getUserInfo();
                  },
                });
              }
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    getUserInfo() {
      getUserInfo().then((res) => {
        localStorage.setItem(`user`, JSON.stringify(res));
        localStorage.setItem(`sCode`, res.scode);
        localStorage.setItem(`uvCode`, res.uvCode);
        let redirectURI = this.$route.query.redirectURI;
        if (redirectURI) {
          window.location.href = decodeURIComponent(redirectURI);
        } else {
          this.$router.push({ path: "/home" });
        }

        // 延迟 1 秒显示欢迎信息
        setTimeout(() => {
          this.$notification.success({
            message: "欢迎",
            description: `${timeFix()}，欢迎回来`,
          });
        }, 1000);
      });
    },
    getWebConfig() {
      if (this.$route.query.uvCode && this.$route.query.uvCode != "undefined") {
        getWebConfig({
          uvCode: this.$route.query.uvCode,
        }).then((res) => {
          if (res.title) {
            this.systemName = res.title;
            localStorage.setItem("systemName", this.systemName);
          }
          if (res.schoolLogo) {
            this.schoolLogo = res.schoolLogo;
            localStorage.setItem("schoolLogo", this.schoolLogo);
          }
          if (res.sysLogo) {
            this.systemLogo = res.sysLogo;
            localStorage.setItem("systemLogo", this.systemLogo);
          }
          if (res.pcStu) {
            this.systemBgUrl = res.pcStu;
            localStorage.setItem("systemBgUrl", this.systemBgUrl);
          }
        });
      }
    },
    getQriously() {
      getQriously({ type: "1", uvCode: this.$route.query.uvCode }).then(
        (res) => {
          if (res) {
            this.codeValue = `${res.url}?uvCode=${this.$route.query.uvCode}`;
            // console.log(this.codeValue, "214323893");
          }
        }
      );
    },
  },
  mounted() {
    if (this.$route.query.uvCode) {
      console.log(this.$route.query, "219329832923");
      localStorage.setItem("uvCode", this.$route.query.uvCode);
      // this.codeValue = `https://msignup.q-edu.net/#/pages/single/user/login?uvCode=${this.$route.query.uvCode}`;
      // this.codeValue = `http://cs-dz-m.testing.yingxinbao.net/#/pages/single/user/login?uvCode=${this.$route.query.uvCode}`
    }

    localStorage.setItem("systemName", this.systemName);
    // localStorage.setItem('schoolLogo', this.schoolLogo)
    // localStorage.setItem('systemLogo', this.systemLogo)
    localStorage.setItem("systemBgUrl", this.systemBgUrl);
    this.getWebConfig();
    this.getQriously();
    const isKeepPsd = localStorage.getItem("isKeep") || false;
    const username = localStorage.getItem("username");
    const password = localStorage.getItem("password");
    this.isKeep = isKeepPsd;
    this.form.setFieldsValue({
      username: username && isKeepPsd ? username : "",
      password: password && isKeepPsd ? password : "",
    });
  },
};
</script>

<style lang="less" scoped>
.userPage {
  // background: url(~@/assets/pcStu.png) no-repeat;
  background-size: cover !important;
  min-height: 100%;
  width: 100%;
}
.wrap {
  width: 876px;
  margin: 0px auto;
  padding-bottom: 32px;
  .sysName {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 110px 0 52px;
    text-align: center;
    img {
      height: 67px;
    }
    .line {
      width: 1px;
      height: 36px;
      border-right: 1px solid rgba(255, 255, 255, 0.6);
      margin: 0px 20px;
    }
    .name {
      font-size: 40px;
      color: #ffffff;
    }
  }
  .con {
    display: flex;
    width: 876px;
    height: 468px;
    background: #fff;
    border-radius: 8px;
    h3 {
      font-size: 24px;
      color: #000;
      margin-bottom: 38px;
    }
  }
  .mobile {
    width: 438px;
    padding: 58px 56px 0px;
    .ewm {
      width: 230px;
      height: 230px;
      margin: 6px auto 0;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      text-align: center;
    }
    img {
      width: 100%;
    }
    .desc {
      font-size: 16px;
      color: #ff5d5d;
      margin-top: 18px;
    }
  }
  .user {
    width: 437px;
    padding: 58px 56px 0px;
    border-left: 1px solid #ededed;
  }
}
/* 客服在线服务（已隐藏，保留代码）
.fixed {
  position: fixed;
  right: 0;
  bottom: 160px;
  width: 46px;
  height: 110px;
  background: #ffffff;
  border-radius: 6px 0 0 6px;
  font-size: 14px;
  color: #666666;
  padding: 12px 8px;
  text-align: center;
  cursor: pointer;
  .icon {
    width: 24px;
    height: 24px;
    margin: 0 auto 3px;
    background: url(~@/assets/qrcode.png);
  }
  &:hover {
    color: #2a79ff;
    .icon {
      background: url(~@/assets/qrcode_a.png);
    }
    .groupImg {
      display: block;
    }
  }
  .groupImg {
    width: 149px;
    height: 176px;
    background: #ffffff;
    border-radius: 6px;
    font-size: 14px;
    color: #333;
    padding: 10px;
    position: absolute;
    right: 50px;
    bottom: -30px;
    display: none;
    img {
      width: 100%;
      margin-bottom: 8px;
    }
  }
}
*/
</style>
